import { Theme } from 'src/app/modules/shared/models';
import { MapboxHelper } from '../mapbox-map-helper';
import { MapLayerRenderer } from '../mapbox-map-layer-renderer';
import { IconLayerOptions, Layers } from '../models';
import { CircleLayerOptions } from '../models/circle-layer-options';


export class RenderTimingPointLayer extends MapLayerRenderer {
    constructor(
        protected _mapboxHelper: MapboxHelper,
        private _theme: Theme = Theme.Light
    ) {
        super(_mapboxHelper);
    }

    protected modifyFeatureCollection(fc: GeoJSON.FeatureCollection): GeoJSON.FeatureCollection {
        return fc;
    }

    protected renderLayers(map: mapboxgl.Map): void {
        const layers = {};
        layers[Layers.TimingPoint] = [];

        const stopIconlayerId = `${Layers.TimingPoint}`;
        if (!this._mapboxHelper.layerExists(map, stopIconlayerId)) {
            let layerNames = [];
            const options = this._mainTimingPointOptions();
            layerNames = this._mapboxHelper.renderCircle(map, this._sourceId, this._sourceLayer, stopIconlayerId, options);
            layers[Layers.TimingPoint] = layers[Layers.TimingPoint].concat(layerNames);
        }

        this.addLayerNames(layers);
    }

    //#region rendering options for layers connected to stops
    private _mainTimingPointOptions(): CircleLayerOptions {
        const options = new CircleLayerOptions();

        options.visibleFrom = 14;
        options.visibleTo = 24;
        options.visibility = true;

        options.radius = [
            'interpolate', ['linear'], ['zoom'],
            // zoom is 14 (or less) -> circle radius will be 0px
            14, 0,
            // zoom is 16 (or less) -> circle radius will be 2px
            16, 2,
            // zoom is 18 (or greater) -> circle radius will be 3px
            18, 3,
            24, 4
        ];

        options.color = '#FFFFFF';
        options.strokeColor = '#75c1ff';
        options.strokeWidth = 1;

        options.layerBefore = Layers.Vehicle;
        return options;
    }
    //#endregion

}


